import { works } from "@/mocks/works";
import SectionHeading from "@/components/feature/SectionHeading";
import WorkCard from "@/components/feature/WorkCard";

const hotWorks = [...works].sort((a, b) => b.views - a.views).slice(0, 6);

export default function HotWorks() {
  return (
    <section>
      <SectionHeading
        eyebrow="POPULAR"
        title="热门作品推荐"
        description="根据观众浏览热度整理的近期最受关注作品，点击卡片即可查看详细资料与剧照。"
        actionLabel="查看全部作品"
        actionTo="/works"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {hotWorks.map((work) => (
          <WorkCard key={work.id} work={work} />
        ))}
      </div>
    </section>
  );
}